import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const ShopCategoryFilter = lazy(()=>import('../../components/Shop/ShopCategoryFilter'))

const ShopCategoryPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <ShopCategoryFilter/>
            </Suspense>
        </Fragment>
    );
};

export default ShopCategoryPage;